// List of quotes that will be displayed with the user's name
export const quotes = [
  {
    text: "Pozdravljeni, {name}! Uspeh ni ključ do sreče. Sreča je ključ do uspeha."
  },
  {
    text: "Dobrodošli nazaj, {name}! Ne dovolite, da vam strah pred neuspehom prepreči, da bi poskusili."
  },
  {
    text: "{name}, če hočete spremeniti svet, začnite s seboj."
  },
  {
    text: "Življenje je 10% tistega, kar se vam zgodi, in 90% tistega, kako se na to odzovete. Naprej, {name}!"
  },
  {
    text: "{name}, nikoli ne opusti boja, ker ne veš, kdaj si blizu zmage."
  },
  {
    text: "Dobrodošli, {name}! Ne bojte se sprememb, ker lahko izgubite nekaj dobrega, ampak vedno bodite odprti za nove priložnosti."
  },
  {
    text: "{name}, nič ni nemogoče, beseda samo pravi 'mogoče' z malo drugačno postavitvijo črk."
  },
  {
    text: "Uspeh ne prihaja z zmago, ampak z nenehnim poskusom. Vztrajajte, {name}!"
  },
  {
    text: "{name}, verjemite v sebe in vse, kar ste. Če boste vztrajali, lahko dosežete vse, kar si želite."
  },
  {
    text: "Ne išči izgovorov, poišči načine. Naprej, {name}!"
  },
  {
    text: "{name}, skoči, in mreža se bo pojavila."
  },
  {
    text: "Nič ni trajno, razen sprememb. Pripravljeni, {name}?"
  },
  {
    text: "{name}, najboljši način, da napoveste svojo prihodnost, je, da jo ustvarite sami."
  },
  {
    text: "Ne glede na to, kako počasi greste, ste še vedno hitrejši kot tisti, ki ne naredijo ničesar. Naprej, {name}!"
  },
  {
    text: "{name}, uspeh je kombinacija priložnosti in pripravljenosti nanje."
  },
  {
    text: "Če želite spremeniti svet, {name}, začnite z drobnimi koraki v svojem življenju."
  },
  {
    text: "{name}, za uspeh ni potrebna genialnost, ampak vztrajnost in trdo delo."
  },
  {
    text: "Samo tisti, ki se odpravijo na pot, lahko odkrijejo nove svetove. Srečno pot, {name}!"
  },
  {
    text: "{name}, nikoli ni prepozno, da postanete tisto, kar bi lahko bili."
  },
  {
    text: "Ne čakajte na priložnosti, {name}, ustvarite jih sami."
  }
];

// Function to get a random quote and replace the name placeholder
export function getRandomQuote(name) {
  const randomIndex = Math.floor(Math.random() * quotes.length);
  const quote = quotes[randomIndex];
  return {
    text: quote.text.replace('{name}', name)
  };
}

// Function to get a quote based on time of day
export function getTimeBasedQuote(name) {
  const hour = new Date().getHours();
  let timeBasedQuote;

  if (hour >= 5 && hour < 12) {
    timeBasedQuote = {
      text: `Dobro jutro, {name}! Vsako jutro je nova priložnost za uspeh.`
    };
  } else if (hour >= 12 && hour < 17) {
    timeBasedQuote = {
      text: `Dober dan, {name}! Naj bo vaš dan poln dosežkov.`
    };
  } else {
    timeBasedQuote = {
      text: `Dober večer, {name}! Čas je za pregled današnjih uspehov.`
    };
  }

  return {
    text: timeBasedQuote.text.replace('{name}', name)
  };
}
